export const getBorderStyle = (showBorder = false) => showBorder
    ? 'border border-solid border-gray group-data-secondary:border-white/50 group-data-gray:border-main-divider'
    : '';
//# sourceMappingURL=getBorderStyle.js.map